import useVuelidate, { type ValidationRuleCollection } from "@vuelidate/core";
import { computed, type ComputedRef, unref } from "vue";

export interface FieldValidation {
  invalid: boolean;
  /** The first failing rule's message only, so a field never stacks several. */
  error: string | undefined;
  touch: () => void;
}

/**
 * Validates one signup input against its own rules. The instance reports to the nearest
 * `useVuelidate` above it, so the flow saving the step gates on every input that is mounted, and a
 * field that isn't rendered takes its rules with it.
 */
export function useFieldValidation(
  value: () => unknown,
  rules: () => ValidationRuleCollection
): ComputedRef<FieldValidation> {
  const v$ = useVuelidate(
    computed(() => ({ field: rules() })),
    { field: computed(value) }
  );
  return computed(() => {
    const field = v$.value.field;
    return {
      invalid: field.$error,
      error: unref(field.$errors[0]?.$message),
      touch: field.$touch,
    };
  });
}
